import React from 'react'
import { Avatar, Box, Typography } from '@mui/material'
import styles from './ProfileCard.module.scss'

const ProfileCard = ({ label, image, onClick }) => {
	return (
		<Box
			onClick={onClick}
			className={`${styles.ProfileCard}`}
			sx={{
				...(onClick && { cursor: 'pointer' }),
			}}
		>
			<Avatar src={image} alt={label} className={`${styles.avatar}`}>
				{!image && <img src="/images/Avatar.svg" alt="Avatar.svg" />}
			</Avatar>
			{label && (
				<Typography variant="body2" className={`${styles.text}`}>
					{label}
				</Typography>
			)}
		</Box>
	)
}

export default ProfileCard
